<script lang="ts">
import { defineComponent } from 'vue';
import {
  Dropdown, Menu, MenuItem, MenuDivider, Button,
} from 'ant-design-vue';
import {
  UserOutlined,
  LogoutOutlined,
  DownOutlined,
} from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';

import useLogout from '@/providers/useLogout';
import { useAgentLoggedQuery } from '@/graphql/generated/graphql';
import { userTimezone } from '@/util/dayjsWithTimezone';

export default defineComponent({
  name: 'ProfileMenu',
  components: {
    Dropdown,
    Menu,
    MenuItem,
    MenuDivider,
    Button,
    DownOutlined,
    UserOutlined,
    LogoutOutlined,
  },
  setup() {
    const { fetching, error, data } = useAgentLoggedQuery({});
    const { onLogout, loading } = useLogout();
    const router = useRouter();
    const onProfile = () => {
      router.push('/profile');
    };
    return {
      onLogout,
      onProfile,
      loading,
      fetching,
      error,
      data,
      userTimezone,
    };
  },
});
</script>

<template>
  <Dropdown>
    <button
      class="
        ant-dropdown-link
        h-full
        px-2
        hover:bg-gray-100
        dark:hover:bg-gray-800
      "
      type="button"
      @click.prevent
    >
      {{ data?.agentLogged?.first_name }} {{ data?.agentLogged?.last_name }} <DownOutlined />
    </button>
    <template #overlay>
      <Menu>
        <MenuItem key="0">
          <Button
            type="link"
            style="padding: 0; height: auto; width: 100%; text-align: left;"
            @click="onProfile"
          >
            <UserOutlined /> Profile
          </Button>
        </MenuItem>
        <MenuDivider />
        <MenuItem key="3">
          <Button
            type="link"
            style="padding: 0; height: auto; width: 100%; text-align: left;"
            @click="onLogout"
          >
            <LogoutOutlined /> Logout
          </Button>
        </MenuItem>
        <MenuDivider />
        <MenuItem key="4" disabled>
          User Time Zone: {{ userTimezone }}
        </MenuItem>
      </Menu>
    </template>
  </Dropdown>
</template>
